// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// API and Types
import { getClinicUsers } from "../../api";
import { ClinicUserType } from "../../types";

export const useClinicUsersData = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ClinicUserType>>({
    queryKey: ["clinic-users", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();

      const token = await getToken();
      const controller = new AbortController();
      return getClinicUsers(token, clinicId, controller.signal);
    },
    enabled: Boolean(clinicId), // Prevents query from running if id is undefined
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
